import React, { Component } from 'react';

class FloatContainer extends Component {
    componentDidMount() {
        require("./css/FloatContainer.css");
    }
    render() {
        return (


            <div className="Float_Container">
                {this.props.children}

            </div>

        );
    }
};
export default FloatContainer;